
import { RootState } from '../rmsStore';

export function getDashboardReducer(state: RootState): DashboardState {
  return state.dashboardReducer;
}

